var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"ar-volume"},[_c('icon-button',{staticClass:"ar-volume__icon",attrs:{"name":"volume"}}),_c('line-control',{staticClass:"ar-volume-bar",attrs:{"ref-id":"volume","percentage":_vm.volume},on:{"change-linehead":_vm.onChangeLinehead}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }